import Input from './Input.component';
export type { InputProps } from './Input.component';

export default Input;
